import React from 'react';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-bg-dark py-10 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-177">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" data-id="element-178"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-179">
        <h2 className="text-2xl sm:text-6xl font-serif font-black text-text-main text-center mb-4 sm:mb-16 tracking-tight" data-id="element-180">
          Strategic Launch Offer for Australia
        </h2>

        {/* Featured Card */}
        <div className="bg-white rounded-xl sm:rounded-3xl border border-border-light shadow-[0_10px_40px_rgba(201,137,155,0.1)] px-4 py-5 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-181">
          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-primary text-white font-bold text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_4px_15px_rgba(201,137,155,0.3)]" data-id="element-182">
            ⭐ THE PREMIUM VAULT
          </div>

          <div className="space-y-2 sm:space-y-5 mb-4 sm:mb-10 text-xs sm:text-lg mt-3" data-id="element-183">
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-184">
              <span data-id="element-185">Educational Collection (6 Elite Volumes)</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-186">
                Value $197
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-187">
              <span data-id="element-188">Assessment Registry & Clinical Sheets</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-189">
                Value $87
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-190">
              <span data-id="element-191">Dynamic Pilates & Small Props Manual</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-192">
                Value $119
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-193">
              <span data-id="element-194">6 Exclusive Bonuses</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-195">
                Value $149
              </span>
            </div>
            <div className="flex justify-between text-text-main font-black pt-1.5 sm:pt-4 text-sm sm:text-xl" data-id="element-196">
              <span data-id="element-197">TOTAL IF BOUGHT SEPARATELY:</span>
              <span className="text-badge-red line-through" data-id="element-198">$552</span>
            </div>
          </div>

          {/* Price reveal */}
          <div className="text-center mb-3 sm:mb-8 bg-bg-main border border-border-light py-3 sm:py-8 rounded-lg sm:rounded-2xl relative overflow-hidden" data-id="element-199">
            <p className="text-primary font-bold mb-0.5 sm:mb-2 text-xs sm:text-base" data-id="element-200">
              LIMITED TIME LAUNCH PRICE:
            </p>
            <div className="text-text-main font-serif font-black sm:text-7xl tracking-tighter text-[32px]" data-id="element-201">
              $47 AUD
            </div>
            <div className="text-text-sec text-[10px] sm:text-sm font-medium mt-1 sm:mt-2" data-id="element-202">
              (One-time payment — Lifetime Access to the Vault)
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-primary font-bold text-[10px] sm:text-sm bg-primary/10 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-primary/20 mx-auto mb-3 sm:mb-6" data-id="element-203">
            ⏰ Price will increase once the launch window closes
          </span>

          <a href="https://australia.edulabs.online/cart/43402945331318:1" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'The Pilates Pack — Australian Edition',
              content_type: 'product',
              value: 47.0,
              currency: 'AUD'
            });
          }
        }} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-black sm:text-xl py-3.5 sm:py-6 rounded-xl sm:rounded-2xl hover:bg-cta-green-hover transition-all shadow-[0_8px_25px_rgba(16,185,129,0.25)] mb-2 sm:mb-6 text-[18px] pt-[22px] pb-[22px]" data-id="element-204">
            👉 YES! I WANT THE PACK
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-205">
            <span data-id="element-206">💳 Secure Australian Payment</span>
            <span data-id="element-207">•</span>
            <span data-id="element-208">⚡ Instant Digital Delivery</span>
            <span data-id="element-209">•</span>
            <span data-id="element-210">🛡️ 14-Day Guarantee</span>
          </p>
        </div>
      </div>
    </section>;
}